import { GvfService } from "../../gvf/js/gvf-service";
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";

class FcmService {
    constructor() {
        this.messaging = null;
    }

    sendTokenToServer(currentToken) {
        if (!this.isTokenSentToServer()) {
            GvfService.endpoint("/cp/cp-device/register-token", { token: currentToken }).then(() => {
                this.setTokenSentToServer(true);
            });
        }
    }

    isTokenSentToServer() {
        return window.localStorage.getItem("sentToServer") === "1";
    }

    setTokenSentToServer(sent) {
        window.localStorage.setItem("sentToServer", sent ? "1" : "0");
    }

    requestPermission(vapidKey) {
        Notification.requestPermission().then(() => {
            getToken(this.messaging, { vapidKey: vapidKey }).then((refreshedToken) => {
                this.setTokenSentToServer(false);
                this.sendTokenToServer(refreshedToken);
            }).catch((err) => {
                console.error("Error getting token: ", err);
            });
        });
    }

    showNotification(payload) {
        if (payload.data && payload.data.notification) {
            const message = JSON.parse(payload.data.notification);
            new Notification(message.title);
        }
    }

    init(vapidKey) {
        const firebaseConfig = {
            apiKey: "AIzaSyAEZObmHoUN9ncOhc3ickQpmrPcM4mHn68",
            authDomain: "goventure-base-project.firebaseapp.com",
            projectId: "goventure-base-project",
            storageBucket: "goventure-base-project.appspot.com",
            messagingSenderId: "124893919042",
            appId: "1:124893919042:web:6994b539c0b762bf9c7adb"
        };

        const app = initializeApp(firebaseConfig);

        try {
            this.messaging = getMessaging(app);

            onMessage(this.messaging, (payload) => {
                if (!("Notification" in window)) {
                    alert("This browser does not support desktop notification");
                } else if (Notification.permission === "granted") {
                    this.showNotification(payload);
                } else if (Notification.permission !== "denied") {
                    Notification.requestPermission().then((permission) => {
                        if (permission === "granted") {
                            this.showNotification(payload);
                        }
                    });
                }
            });

            //this.requestPermission(vapidKey);
        } catch (e) {
            console.log(e);
        }
    }
}

const s_FcmService = new FcmService();
export { s_FcmService as FcmService };
